import { apiRequest } from '../api-request'
import { ExceptionType, GOCException } from 'exceptions'
import { CanDoResultDto } from './class-result-adapter'
import { Guid } from './types'

export type ClassStudentResultDto = {
    studentReferenceId: Guid
    resultType: number | null
    comment: string
    score: number | null
    canDoResults?: CanDoResultDto[] | null
    isLevelChangeRecommended?: boolean | null
    levelChangeComment?: string | null
    isAdvisingSessionRecommended?: boolean | null
    advisingSessionComment?: string | null
}

export type ClassResultResponse = {
    classId: Guid
    teacherId: Guid
    isClosed: boolean
    results: ClassStudentResultDto[]
}

type ClassResultApiResponse = Omit<ClassResultResponse, 'results'> & {
    results: ClassStudentResultDto[] | null
}

export const normalizeClassResultResponse = (
    response: ClassResultApiResponse,
    classId: string
): ClassResultResponse => ({
    classId: response.classId ?? classId,
    teacherId: response.teacherId,
    isClosed: response.isClosed ?? false,
    results: response.results ?? []
})

const getClassResult = async (auth: string, classId: string): Promise<ClassResultResponse> => {
    const effectiveAuth = process.env.REACT_APP_QUALWORLD_AUTH || auth

    if (!effectiveAuth.trim() || !classId.trim()) {
        throw new GOCException(ExceptionType.HttpError, 'Auth token and classId are required')
    }

    if (!process.env.REACT_APP_USE_ASSESSMENT_MOCKS) {
        const response = await apiRequest<ClassResultApiResponse>({
            baseUrl: process.env.REACT_APP_CORE_COURSE_WEB_URL,
            path: `/bookapi/api/class/${classId}/result`,
            method: 'GET',
            auth: effectiveAuth
        })

        return normalizeClassResultResponse(response, classId)
    }

    const { mock } = await import('./mocks/results')
    return new Promise(resolve => setTimeout(() => resolve(normalizeClassResultResponse(mock, classId)), 300))
}

export { getClassResult }
